import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let kejianrouter = new Router({
    routes: [
        {
            path: '/',
            name: 'ceshihome',
            component: () => import('./views/ceshihome.vue'),
            hidden: true,
            redirect: 'Home',
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: () => import('./views/Home.vue')
                },{
                    path: '/aboutUs',
                    name: 'aboutUs',
                    component: () => import('./views/aboutUs/index.vue')
                },{
                    path: '/customerCase',
                    name: 'customerCase',
                    component: () => import('./views/customerCase/index.vue')
                },{
                    path: '/product',
                    name: 'product',
                    component: () => import('./views/product/index.vue')
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('./views/Login.vue')
        },
    ]
})

// 判断是否需要登录权限 以及是否登录
kejianrouter.beforeEach((to, from, next) => {
    // 判断是否需要登录权限
    if (to.matched.some(res => res.meta.requireAuth)) {
        // 判断是否登录
        if (sessionStorage.getItem('token')) {
            next()
        } else {
            // 没登录则跳转到登录界面
            next({
                path: '/login',
                query: {
                    redirect: to.fullPath
                }
            })
        }
    } else {
        next()
    }
})

export default kejianrouter
